import React, { useMemo } from "react";

const DEBUG = false;

/**
 * ============================================================
 * GUIDE — FILTRES TYPE DE LAIT
 * ============================================================
 */
const getMilkFilters = (t = {}) => [
  {
    value: "",
    label: t?.allMilkTypes || "Tous les laits",
  },
  {
    value: "lait cru",
    label: t?.milkTypeRaw || "Lait cru",
  },
  {
    value: "pasteurisé",
    label: t?.milkTypePasteurized || "Pasteurisé",
  },
  {
    value: "thermisé",
    label: t?.milkTypeThermized || "Thermisé",
  },
];

/**
 * ============================================================
 * ICÔNES — STYLE ILLUSTRATION PREMIUM
 * ============================================================
 */
function CategoryIcon({ type }) {
  const normalized = String(type || "").toLowerCase();

  if (normalized.includes("chèvre") || normalized.includes("brebis")) {
    return (
      <svg
        viewBox="0 0 72 72"
        className="md-category-icon-svg"
        aria-hidden="true"
      >
        <path className="soft" d="M20 28c-5-8-10-11-15-10 1 9 7 14 14 17" />
        <path className="soft" d="M52 28c5-8 10-11 15-10-1 9-7 14-14 17" />
        <path d="M22 31c0-12 28-12 28 0v10c0 10-6 17-14 17s-14-7-14-17V31Z" />
        <path d="M28 30c-3-8 0-14 5-18" />
        <path d="M44 30c3-8 0-14-5-18" />
        <path d="M30 42h.1" />
        <path d="M42 42h.1" />
        <path d="M32 50c3 2 5 2 8 0" />
        <path className="shade" d="M27 35c5-4 13-4 18 0" />
      </svg>
    );
  }

  if (normalized.includes("épicerie") || normalized.includes("epicerie")) {
    return (
      <svg
        viewBox="0 0 72 72"
        className="md-category-icon-svg"
        aria-hidden="true"
      >
        <path d="M15 30h42l-5 30H20L15 30Z" />
        <path d="M25 30c1-12 7-20 11-20s10 8 11 20" />
        <path className="shade" d="M20 38h34" />
        <path className="shade" d="M22 47h30" />
        <path className="shade" d="M25 56h22" />
        <path className="soft" d="M14 30c-4-6 1-12 8-9" />
        <path className="soft" d="M58 30c4-6-1-12-8-9" />
      </svg>
    );
  }

  if (normalized.includes("fondue")) {
    return (
      <svg
        viewBox="0 0 72 72"
        className="md-category-icon-svg"
        aria-hidden="true"
      >
        <path d="M19 34h34v10c0 10-7 17-17 17s-17-7-17-17V34Z" />
        <path d="M15 34h42" />
        <path d="M25 61h22" />
        <path d="M27 23c-4-5 4-8 0-13" />
        <path d="M36 23c-4-5 4-8 0-13" />
        <path d="M45 23c-4-5 4-8 0-13" />
        <path className="soft" d="M19 42H9" />
        <path className="soft" d="M63 42H53" />
        <path className="shade" d="M25 43c7 4 15 4 22 0" />
      </svg>
    );
  }

  if (
    normalized.includes("persillé") ||
    normalized.includes("persille") ||
    normalized.includes("bleu")
  ) {
    return (
      <svg
        viewBox="0 0 72 72"
        className="md-category-icon-svg"
        aria-hidden="true"
      >
        <path d="M13 42 42 18l18 10-30 24-17-10Z" />
        <path d="M30 52v11l30-24V28" />
        <path d="M13 42v11l17 10" />
        <circle cx="35" cy="39" r="2.5" />
        <circle cx="44" cy="33" r="1.8" />
        <circle cx="25" cy="45" r="1.8" />
        <circle cx="39" cy="47" r="1.5" />
        <path className="shade" d="M21 56c5-4 8-1 12-5" />
      </svg>
    );
  }

  if (normalized.includes("molle")) {
    return (
      <svg
        viewBox="0 0 72 72"
        className="md-category-icon-svg"
        aria-hidden="true"
      >
        <path d="M13 39c0-10 10-18 23-18s23 8 23 18v15H13V39Z" />
        <path d="M13 39c11 6 35 6 46 0" />
        <path d="M43 47h16v15H43z" />
        <path d="M48 51h.1" />
        <path d="M54 56h.1" />
        <circle cx="25" cy="46" r="2.2" />
        <circle cx="35" cy="39" r="1.8" />
        <path className="shade" d="M20 54h22" />
      </svg>
    );
  }

  if (normalized.includes("dur") || normalized.includes("mi-dur")) {
    return (
      <svg
        viewBox="0 0 72 72"
        className="md-category-icon-svg"
        aria-hidden="true"
      >
        <path d="M13 40c0-10 10-18 23-18s23 8 23 18v14H13V40Z" />
        <path d="M13 40c11 6 35 6 46 0" />
        <path d="M42 46h17v16H42z" />
        <path d="M48 50h.1" />
        <path d="M54 55h.1" />
        <path className="shade" d="M23 48c7 3 13 3 20 0" />
      </svg>
    );
  }

  if (normalized.includes("raclette")) {
    return (
      <svg
        viewBox="0 0 72 72"
        className="md-category-icon-svg"
        aria-hidden="true"
      >
        <path d="M14 38h31l11 8-32 9-10-8v-9Z" />
        <path d="M14 38 45 30l11 8-32 9-10-9Z" />
        <path d="M24 55v8" />
        <path d="M53 46l8 8" />
        <path d="M48 49l9 9" />
        <path className="shade" d="M26 41h18" />
      </svg>
    );
  }

  if (normalized.includes("yogourt") || normalized.includes("yaourt")) {
    return (
      <svg
        viewBox="0 0 72 72"
        className="md-category-icon-svg"
        aria-hidden="true"
      >
        <path d="M24 22h24l-4 39H28L24 22Z" />
        <path d="M22 16h28v6H22z" />
        <path className="shade" d="M29 33h14" />
        <path d="M31 45c3 4 9 4 12 0" />
        <path className="soft" d="M49 18c6-6 11-6 15-2" />
        <path className="soft" d="M54 14c2 3 2 6-1 9" />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 72 72"
      className="md-category-icon-svg"
      aria-hidden="true"
    >
      <path d="M21 21h11v11H21z" />
      <path d="M40 21h11v11H40z" />
      <path d="M21 40h11v11H21z" />
      <path d="M40 40h11v11H40z" />
    </svg>
  );
}

export default function CategoryGrid({
  categoriesAffichees = [],
  categorieActive,
  setCategorieActive,
  vueActuelle,
  catLoading,
  t,
  produits = [],
  typeLaitActif = "",
  setTypeLaitActif = null,
  afficherFiltreLait = false,
}) {
  const safeProducts = useMemo(
    () => (Array.isArray(produits) ? produits : []),
    [produits]
  );

  const safeCategories = useMemo(
    () => (Array.isArray(categoriesAffichees) ? categoriesAffichees : []),
    [categoriesAffichees]
  );

  const milkFilters = useMemo(() => getMilkFilters(t), [t]);

  if (DEBUG) {
    console.log("DEBUG CategoryGrid catégories à afficher:", safeCategories);
  }

  const handleSetCategory = (catName) => {
    if (typeof setCategorieActive === "function") {
      setCategorieActive(catName);
    }
  };

  const handleSetMilkType = (value) => {
    if (typeof setTypeLaitActif === "function") {
      setTypeLaitActif(value);
    }
  };

  const countProductsForCategory = (catName) => {
    return safeProducts.filter((p) => {
      const catProduit = p?.category || p?.categorie;
      if (catProduit !== catName) return false;

      if (vueActuelle === "magasin") {
        const isOnline = Number(p?.isOnline) === 1 || p?.isOnline === true;
        if (!isOnline) return false;
      }

      if (typeLaitActif) {
        const productMilkType = String(p?.type_lait || "").trim();
        if (productMilkType !== typeLaitActif) return false;
      }

      return true;
    }).length;
  };

  const visibleCategories = useMemo(() => {
    return safeCategories
      .filter((cat) => {
        if (!cat) return false;

        return safeProducts.some((p) => {
          const catProduit = p?.category || p?.categorie;
          if (catProduit !== cat.name) return false;

          if (vueActuelle === "magasin") {
            const isOnline = Number(p?.isOnline) === 1 || p?.isOnline === true;
            if (!isOnline) return false;
          }

          if (typeLaitActif) {
            const productMilkType = String(p?.type_lait || "").trim();
            if (productMilkType !== typeLaitActif) return false;
          }

          return true;
        });
      })
      .map((cat) => ({
        key: `${vueActuelle}-${cat.name}`,
        name: cat.name,
        label: cat.label || cat.name,
        count: countProductsForCategory(cat.name),
      }));
  }, [safeCategories, safeProducts, vueActuelle, typeLaitActif]);

  return (
    <section className="md-category-shell">
      <div className="md-category-head">
        <div className="md-category-kicker">
          <span />
          {t?.categoriesKicker || "Parcourir"}
          <span />
        </div>

        <h2 className="md-category-title">
          {t?.categoriesTitle || "Notre sélection"}
        </h2>

        <p className="md-category-subtitle">
          {t?.categoriesSubtitle ||
            "Choisissez une famille de produits et explorez notre sélection."}
        </p>
      </div>

      {afficherFiltreLait ? (
        <div className="md-milk-filter-shell">
          <div className="md-milk-filter-head">
            <span className="md-milk-filter-kicker">
              {t?.milkTypeFilterKicker || "Affiner"}
            </span>
            <h3 className="md-milk-filter-title">
              {t?.milkTypeFilterTitle || "Type de lait"}
            </h3>
          </div>

          <div className="md-milk-filter-row">
            {milkFilters.map((item) => (
              <button
                key={item.value || "all-milk"}
                type="button"
                className={`md-milk-chip ${
                  typeLaitActif === item.value ? "active" : ""
                }`}
                onClick={() => handleSetMilkType(item.value)}
              >
                <span className="md-milk-chip-dot" />
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        </div>
      ) : null}

      <div className="md-category-grid">
        {catLoading ? (
          <div className="md-category-loading">
            {t?.loadingCategories || "Chargement..."}
          </div>
        ) : (
          visibleCategories.map((cat) => (
            <button
              key={cat.key}
              type="button"
              className={`md-category-card ${
                categorieActive === cat.name ? "active" : ""
              }`}
              onClick={() => handleSetCategory(cat.name)}
            >
              <span className="md-category-icon">
                <CategoryIcon type={cat.label} />
              </span>

              <span className="md-category-dot" />

              <h3>{cat.label}</h3>

              <span className="md-category-arrow">›</span>
            </button>
          ))
        )}
      </div>

      <style>{`
        .md-category-shell {
          max-width: 1280px;
          margin: 26px auto 14px;
          padding: 0 34px;
        }

        .md-category-head {
          text-align: center;
          margin-bottom: 22px;
        }

        .md-category-kicker {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          font-family: var(--font-sans, Inter, Arial, sans-serif);
          font-size: 11px;
          letter-spacing: 0.19em;
          text-transform: uppercase;
          color: #b58a2e;
          margin-bottom: 9px;
          font-weight: 700;
        }

        .md-category-kicker span {
          display: block;
          width: 28px;
          height: 1px;
          background: rgba(181, 138, 46, 0.34);
        }

        .md-category-title {
          font-family: var(--font-serif, Georgia, "Times New Roman", serif);
          font-size: clamp(1.75rem, 2.8vw, 2.35rem);
          line-height: 1.05;
          letter-spacing: -0.015em;
          margin: 0;
          color: #14110d;
          font-weight: 500;
        }

        .md-category-subtitle {
          margin: 10px auto 0;
          max-width: 680px;
          font-family: var(--font-serif, Georgia, "Times New Roman", serif);
          font-size: 1rem;
          line-height: 1.55;
          color: rgba(20, 17, 13, 0.64);
        }

        .md-milk-filter-shell {
          margin: 0 auto 28px;
          max-width: 760px;
          padding: 4px 0 0;
          background: transparent;
          border: 0;
          box-shadow: none;
        }

        .md-milk-filter-head {
          text-align: center;
          margin-bottom: 15px;
        }

        .md-milk-filter-kicker {
          display: inline-block;
          font-family: var(--font-sans, Inter, Arial, sans-serif);
          font-size: 10px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #b58a2e;
          margin-bottom: 7px;
          font-weight: 700;
        }

        .md-milk-filter-title {
          margin: 0;
          font-family: var(--font-serif, Georgia, "Times New Roman", serif);
          font-size: 1.15rem;
          color: #14110d;
          font-weight: 500;
        }

        .md-milk-filter-row {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 22px;
          flex-wrap: wrap;
        }

        .md-milk-chip {
          appearance: none;
          border: 1px solid rgba(181, 138, 46, 0.19);
          background: rgba(255, 255, 255, 0.76);
          color: #1d1913;
          border-radius: 999px;
          padding: 12px 20px;
          min-height: 44px;
          display: inline-flex;
          align-items: center;
          gap: 9px;
          cursor: pointer;
          font-family: var(--font-sans, Inter, Arial, sans-serif);
          font-size: 0.91rem;
          font-weight: 700;
          box-shadow: 0 10px 24px rgba(0, 0, 0, 0.025);
          transition: transform 0.22s ease, box-shadow 0.22s ease,
            border-color 0.22s ease, background 0.22s ease;
        }

        .md-milk-chip:hover {
          transform: translateY(-1px);
          border-color: rgba(181, 138, 46, 0.38);
          background: #fffdf8;
          box-shadow: 0 14px 30px rgba(0, 0, 0, 0.045);
        }

        .md-milk-chip.active {
          border-color: rgba(181, 138, 46, 0.72);
          background: rgba(255, 253, 247, 0.96);
          box-shadow: 0 12px 28px rgba(181, 138, 46, 0.1);
        }

        .md-milk-chip-dot {
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: linear-gradient(135deg, #d8b44a, #b58a2e);
          flex: 0 0 9px;
          box-shadow: 0 0 0 3px rgba(181, 138, 46, 0.08);
        }

        .md-category-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 12px 24px;
          padding-top: 10px;
          border-top: 1px solid rgba(181, 138, 46, 0.24);
        }

        .md-category-card {
          appearance: none;
          position: relative;
          display: grid;
          grid-template-columns: 82px 14px minmax(0, 1fr) 18px;
          align-items: center;
          gap: 16px;
          width: 100%;
          min-height: 94px;
          border: 1px solid rgba(35, 29, 20, 0.075);
          border-top-color: rgba(181, 138, 46, 0.22);
          background: rgba(255, 255, 255, 0.76);
          border-radius: 9px;
          padding: 8px 22px 8px 10px;
          text-align: left;
          cursor: pointer;
          box-shadow: 0 10px 24px rgba(0, 0, 0, 0.035);
          overflow: hidden;
          transition: transform 0.22s ease, box-shadow 0.22s ease,
            border-color 0.22s ease, background 0.22s ease;
        }

        .md-category-card::before {
          content: "";
          position: absolute;
          inset: 0;
          opacity: 0;
          background: linear-gradient(
            90deg,
            rgba(181, 138, 46, 0.075),
            rgba(255, 255, 255, 0)
          );
          transition: opacity 0.22s ease;
          pointer-events: none;
        }

        .md-category-card:hover {
          transform: translateY(-2px);
          background: rgba(255, 255, 255, 0.96);
          border-color: rgba(181, 138, 46, 0.28);
          box-shadow: 0 16px 34px rgba(0, 0, 0, 0.055);
        }

        .md-category-card:hover::before,
        .md-category-card.active::before {
          opacity: 1;
        }

        .md-category-card.active {
          border-color: rgba(181, 138, 46, 0.48);
          background: rgba(255, 253, 247, 0.94);
          box-shadow: 0 14px 34px rgba(181, 138, 46, 0.09);
        }

        .md-category-icon {
          width: 70px;
          height: 70px;
          border-radius: 999px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background:
            radial-gradient(circle at 32% 22%, rgba(255, 255, 255, 1), rgba(247, 242, 232, 0.88)),
            rgba(255, 255, 255, 0.82);
          border: 1px solid rgba(181, 138, 46, 0.16);
          box-shadow:
            inset 0 1px 0 rgba(255, 255, 255, 0.95),
            0 8px 18px rgba(0, 0, 0, 0.04);
          color: #a77b26;
          z-index: 1;
        }

        .md-category-icon-svg {
          width: 46px;
          height: 46px;
          fill: none;
          stroke: currentColor;
          stroke-width: 2.05;
          stroke-linecap: round;
          stroke-linejoin: round;
          filter:
            drop-shadow(0 1px 0 rgba(255, 255, 255, 0.95))
            drop-shadow(0 4px 5px rgba(70, 49, 20, 0.08));
        }

        .md-category-icon-svg .soft {
          stroke: rgba(120, 95, 53, 0.72);
          stroke-width: 1.8;
        }

        .md-category-icon-svg .shade {
          stroke: rgba(181, 138, 46, 0.46);
          stroke-width: 1.55;
        }

        .md-category-dot {
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: linear-gradient(135deg, #d8b44a, #b58a2e);
          flex: 0 0 9px;
          box-shadow: 0 0 0 4px rgba(181, 138, 46, 0.08);
          z-index: 1;
        }

        .md-category-card h3 {
          margin: 0;
          font-family: var(--font-serif, Georgia, "Times New Roman", serif);
          font-size: 1.16rem;
          line-height: 1.15;
          color: #14110d;
          font-weight: 700;
          letter-spacing: -0.018em;
          z-index: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .md-category-arrow {
          font-family: var(--font-serif, Georgia, "Times New Roman", serif);
          font-size: 2rem;
          line-height: 1;
          color: #b58a2e;
          font-weight: 300;
          z-index: 1;
          transform: translateY(-1px);
        }

        .md-category-loading {
          grid-column: 1 / -1;
          padding: 22px;
          text-align: center;
          border-radius: 9px;
          background: rgba(255, 255, 255, 0.82);
          border: 1px solid rgba(181, 138, 46, 0.16);
          color: rgba(20, 17, 13, 0.68);
          font-family: var(--font-serif, Georgia, "Times New Roman", serif);
        }

        @media (max-width: 920px) {
          .md-category-shell {
            padding: 0 18px;
          }

          .md-category-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 12px;
          }

          .md-category-card {
            grid-template-columns: 58px 10px minmax(0, 1fr) 13px;
            gap: 10px;
            min-height: 82px;
            padding: 8px 12px 8px 7px;
          }

          .md-category-icon {
            width: 52px;
            height: 52px;
          }

          .md-category-icon-svg {
            width: 35px;
            height: 35px;
          }

          .md-category-card h3 {
            font-size: 1rem;
          }
        }

        @media (max-width: 520px) {
          .md-category-shell {
            padding: 0 12px;
            margin-top: 18px;
          }

          .md-category-kicker {
            gap: 10px;
          }

          .md-category-kicker span {
            width: 20px;
          }

          .md-category-title {
            font-size: 1.7rem;
          }

          .md-category-subtitle {
            font-size: 0.92rem;
          }

          .md-milk-filter-row {
            justify-content: center;
            gap: 8px;
          }

          .md-milk-chip {
            padding: 8px 10px;
            font-size: 0.74rem;
            min-height: 38px;
          }

          .md-category-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 10px;
          }

          .md-category-card {
            min-height: 92px;
            grid-template-columns: 1fr;
            justify-items: center;
            text-align: center;
            gap: 7px;
            padding: 10px 8px;
          }

          .md-category-icon {
            width: 50px;
            height: 50px;
          }

          .md-category-icon-svg {
            width: 33px;
            height: 33px;
          }

          .md-category-dot,
          .md-category-arrow {
            display: none;
          }

          .md-category-card h3 {
            font-size: 0.82rem;
            line-height: 1.12;
            white-space: normal;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      `}</style>
    </section>
  );
}
